import styled from "styled-components";
import {Select, Input} from "antd";
import {useApp} from "../../../contexts";
import {useEffect, useState} from "react";
import {getPhoneCodes} from "../../../services/app";
import {FormInput} from "../../../components/Form";

export const Text = styled.div`
  max-width: 450px;
  font-weight: 400;
  font-size: 16px;
  line-height: 25px;
  text-align: center;
  color: #707070;
  margin-bottom: 56px;
`;

const PhoneContainer = styled.div`
  position: relative;
`;
const PhoneSelectRow = styled.div`
  display: flex;
  align-items: center;
  position: absolute;
  top: 7px;
  left: 12px;
  z-index: 1;
  border-right: 1px solid rgba(0, 0, 0, 0.1);
  height: 39px;
  padding-right: 12px;


  & span {
    font-weight: 400;
    font-size: 16px;
    line-height: 25px;
    color: #707070;
    margin-right: 9px;
  }
`;
const PhoneSelectFlag = styled.div`
  height: 21px;
  margin-top: -4px;

  & img {
    height: 100%;
    width: auto;
  }
`;

const PhoneInput = styled(FormInput)`
  padding-left: 115px;
`;

const Dropdown = styled.div`
  background: #FFFFFF;
  box-shadow: 0px 10px 30px rgb(77 103 193 / 15%);
  border-radius: 10px;
  border: none;
  padding: 22px;
  font-size: 16px;
  position: absolute;
  width: 100%;
  top: 54px;
  z-index: 3;
  box-sizing: border-box;
`;
const DropdownSearch = styled.div`
  border-bottom: 1px solid lightgray;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding-bottom: 12px;
  margin-bottom: 12px;

  & svg {

  }
`;
const DropdownSearchInput = styled.input`
  font-weight: 400;
  font-size: 15px;
  flex: 1;
  margin-left: 20px;
`;
const DropdownItems = styled.div`
  max-height: 300px;
  overflow-y: auto;
`;
const DropdownItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  padding: 12px 0;

  & h3 {
    margin: 0;
    flex: 1;
    font-weight: 400;
    font-size: 16px;
    color: #707070;
  }

  & span {
    margin: 0;
    font-weight: 400;
    font-size: 15px;
    color: #a5a5a5;
  }

  & img {
    height: 20px;
    width: 30px;
    margin-right: 6px;
  }

  &:hover h3 {
    color: #3D3D3D;
  }
`;

export const FormPhoneInput = (props) => {
    const {T} = useApp();
    const [code, setCode] = useState('');
    const [phone, setPhone] = useState('');
    const [codes, setCodes] = useState([]);
    const [search, setSearch] = useState("");
    const [dropdown, setDropdown] = useState(false);

    useEffect(() => {
        getPhoneCodes().then(value => {
            if (value.status === 200) {
                const items = value?.data?.data || [];
                setCodes(items);
                if (items[0]) {
                    setCode(items[0]);
                }
            }
        })
    }, []);

    useEffect(() => {
        props.onChange({
            "countryPhonePrefixId": code.id,
            "phone": phone,
        })
    }, [phone, code]);

    const listCodes = codes?.filter(item => `${item?.prefix_code || ""} ${item?.country_name || ""}`.toLowerCase().includes(search)) || [];

    return (
        <PhoneContainer tabIndex={0} onBlur={({currentTarget, relatedTarget}) => {
            if (currentTarget.contains(relatedTarget)) return;
            setDropdown(false);
        }}>
            <PhoneSelectRow onClick={() => setDropdown(true)}>
                <PhoneSelectFlag>
                    <img
                        src={`https://country-flags.1timetech.com/png100px/${code?.country_code?.toString()?.toLowerCase() || ""}.png`}/>
                </PhoneSelectFlag>
                <span>{code?.prefix_code || ""}</span>
                <svg width="8" height="6" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path opacity="0.5" d="M0 0V2.1024L3.78145 6L7.56245 2.1024V0H0Z" fill="black"/>
                </svg>
            </PhoneSelectRow>
            <PhoneInput onChange={event => setPhone(event.target.value)} value={phone}
                        placeholder={T("Please enter your phone number")}/>
            {
                dropdown ? (
                    <Dropdown>
                        <DropdownSearch>
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M9.16667 15.8333C12.8486 15.8333 15.8333 12.8486 15.8333 9.16667C15.8333 5.48477 12.8486 2.5 9.16667 2.5C5.48477 2.5 2.5 5.48477 2.5 9.16667C2.5 12.8486 5.48477 15.8333 9.16667 15.8333Z"
                                    stroke="#A3A3A3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                <path d="M17.5 17.5L13.875 13.875" stroke="#A3A3A3" strokeWidth="2"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"/>
                            </svg>
                            <DropdownSearchInput value={search} onChange={event => setSearch(event.target.value)}
                                                 placeholder={T("Search")}/>
                            <svg onClick={() => setSearch("")} style={{cursor: "pointer"}} width="20" height="20"
                                 viewBox="0 0 20 20" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <g>
                                    <path
                                        d="M10.0003 18.3327C14.6027 18.3327 18.3337 14.6017 18.3337 9.99935C18.3337 5.39698 14.6027 1.66602 10.0003 1.66602C5.39795 1.66602 1.66699 5.39698 1.66699 9.99935C1.66699 14.6017 5.39795 18.3327 10.0003 18.3327Z"
                                        stroke="#A3A3A3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                    <path d="M12.5 7.5L7.5 12.5" stroke="#A3A3A3" strokeWidth="2" strokeLinecap="round"
                                          strokeLinejoin="round"/>
                                    <path d="M7.5 7.5L12.5 12.5" stroke="#A3A3A3" strokeWidth="2" strokeLinecap="round"
                                          strokeLinejoin="round"/>
                                </g>
                            </svg>
                        </DropdownSearch>
                        <DropdownItems>
                            {(listCodes?.length > 0) ? listCodes?.map((item, index) => {
                                return (
                                    <DropdownItem key={index.toString()} onClick={() => {
                                        setCode(item);
                                        setDropdown(false);
                                    }}>
                                        <img
                                            src={`https://country-flags.1timetech.com/png100px/${item?.country_code?.toString()?.toLowerCase() || ""}.png`}/>
                                        <h3>{item?.country_name || "Japan"}</h3>
                                        <span>{item?.prefix_code || ""}</span>
                                    </DropdownItem>
                                )
                            }) : (
                                <span style={{
                                    textAlign: 'center',
                                    fontSize: 14,
                                    color: "#969696",
                                    display: "flex",
                                    fontWeight: "400",
                                    margin: "12px auto"
                                }}>{T("No data")}</span>
                            )}
                        </DropdownItems>
                    </Dropdown>
                ) : null
            }
        </PhoneContainer>
    )
}